import React, { memo, useCallback, useContext } from 'react';
import { NodeResizer } from 'reactflow';
import { WorkflowNodesContext } from './WorkflowNodesContext';
import './NoteNode.css';

// A free-floating annotation — not a step, carries no handles/connections, and is excluded from
// the topological sort, stepOrder, and every other step-graph computation in WorkflowBuilder
// (those all filter on node.type !== 'noteNode' alongside the existing 'groupNode' exclusion).
// Persisted separately from the steps array (see generateWorkflowJson's `notes` field) so it
// round-trips with the workflow without the execution engine ever seeing it.
function NoteNode({ id, data, selected }) {
  const setNodes = useContext(WorkflowNodesContext);

  const onChange = useCallback(
    (event) => {
      const text = event.target.value;
      setNodes?.((nds) => nds.map((n) => (n.id === id ? { ...n, data: { ...n.data, text } } : n)));
    },
    [id, setNodes]
  );

  return (
    <div className="workflow-note">
      <NodeResizer isVisible={selected} minWidth={140} minHeight={90} color="#cf7f00" />
      {/* The textarea below is nodrag/nopan so a click-drag inside it selects text instead of
          moving the node — which leaves no surface left to grab the note by, since the textarea
          otherwise fills the whole card. This strip is the drag handle (and what you click to
          select the note so the resizer above becomes visible). */}
      <div className="workflow-note-handle" title="Drag to move" />
      <textarea
        className="workflow-note-text nodrag nopan"
        value={data.text || ''}
        onChange={onChange}
        placeholder="Note…"
      />
    </div>
  );
}

export default memo(NoteNode);
